import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import UserProfilesTab from '../components/user/UserProfilesTab';
import * as FiIcons from 'react-icons/fi';

const { FiLogOut, FiHome } = FiIcons;

const UserDashboard = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('profiles'); // Only 'profiles' remains

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  // Only 'profiles' tab remains
  const tabs = [
    { id: 'profiles', label: 'My Profiles' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <img src="https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/6eb52941ad96e193ea6fc16c1e36c535.png" alt="Chaldean Link Logo" className="h-10 w-auto" />
              <span className="text-xl font-bold text-gray-900">My Dashboard</span>
            </div>
            <div className="flex items-center space-x-4">
              <a href="#/" className="flex items-center space-x-2 text-gray-600 hover:text-yellow-500 transition-colors">
                <SafeIcon icon={FiHome} className="text-lg" />
                <span>View Site</span>
              </a>
              <button onClick={handleSignOut} className="flex items-center space-x-2 text-gray-600 hover:text-red-600 transition-colors">
                <SafeIcon icon={FiLogOut} className="text-lg" />
                <span>Sign Out</span>
              </button>
            </div>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Content Manager</h1>
          <p className="text-gray-600 mb-8">Manage your submitted profiles.</p>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="border-b border-gray-200">
              <nav className="flex overflow-x-auto">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                      activeTab === tab.id
                        ? 'border-yellow-500 text-yellow-500'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>
            <div className="p-6">
              {activeTab === 'profiles' && <UserProfilesTab />}
            </div>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default UserDashboard;